type Props = {
  children:   string | React.ReactNode;
  className?: string;
  index:      number;
  onClick?:   () => unknown;
  style?:     React.CSSProperties;
};

const TabBarTitle = ({ style = {}, ...props }: Props) => {
  return (
    <div
      className={props.className}
      onClick={props.onClick}
      style={style}>
      {props.children}
    </div>
  );
};

export { TabBarTitle };
export default TabBarTitle;